function createFeedHelpers(config) {
  const { container, initialStyles = "", shadowRoot: initialShadowRoot = null } = config;
  const state = {
    totalEntries: 0,
    offset: 0,
    styles: initialStyles,
    shadowRoot: initialShadowRoot
  };
  return {
    setTotalEntries: (count) => {
      state.totalEntries = count;
    },
    setOffset: (count) => {
      state.offset = state.offset + count;
    },
    setStyles: (additionalStyles) => {
      state.styles += additionalStyles;
    },
    setShadowRoot: (shadow) => {
      state.shadowRoot = shadow;
    },
    getContainer: () => container,
    getOffset: () => state.offset,
    getTotalEntries: () => state.totalEntries,
    getStyles: () => state.styles,
    getShadowRoot: () => state.shadowRoot
  };
}
export {
  createFeedHelpers
};
//# sourceMappingURL=feedHelpers.js.map
